const toConvertIdForSegmentId = (discountCouponSegment) => {
  return discountCouponSegment.map((segment) => {
    return { segmentId: segment?.id }
  })
}

export default toConvertIdForSegmentId
